import { memo } from "react";
import { getInitials } from "./initials";
import { AvatarProps } from "./types";

/**
 * Krug s inicijalima kontakt osobe. Korisnici u sustavu nemaju sliku, pa su inicijali
 * jedini prikaz osobe koji nosi informaciju — generička ikona ne govori ništa.
 */
const Avatar: React.FC<AvatarProps> = ({ name }) => (
  <span className="w-11 h-11 text-sm rounded-full bg-sky-50 text-sky-700 border border-sky-100 font-semibold flex items-center justify-center flex-shrink-0">
    {getInitials(name)}
  </span>
);

export default memo(Avatar);
